import { ExclamationCircleIcon } from '@heroicons/react/outline';
import { styled } from '@showroomjs/ui';
import * as React from 'react';
import { Div, H1 } from '../components/base';
import { Seo } from '../components/seo';
export const OfflinePage = () => {
    return (React.createElement(Div, { css: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '100%',
        } },
        React.createElement(Seo, { title: "Offline" }),
        React.createElement(Div, { css: { display: 'flex', flex: 1, overflow: 'hidden' } },
            React.createElement(Div, { as: "main", css: {
                    flex: '1',
                    overflowY: 'auto',
                    paddingTop: '10vh',
                } },
                React.createElement(Div, { css: {
                        maxWidth: '$screenXl',
                        marginX: 'auto',
                        padding: '$6',
                    } },
                    React.createElement(H1, { css: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '$4',
                        } },
                        React.createElement(OfflineIcon, { width: 56, height: 56, "aria-hidden": true }),
                        "Offline"),
                    React.createElement(Div, { as: "p", css: {
                            textAlign: 'center',
                            '@sm': {
                                fontSize: '$xl',
                                lineHeight: '$xl',
                            },
                        } }, "Please try again later."))))));
};
const OfflineIcon = styled(ExclamationCircleIcon, {
    width: 40,
    height: 40,
    display: 'inline-block',
    color: '$gray-400',
    '@sm': {
        width: 56,
        height: 56,
    },
});
//# sourceMappingURL=offline.js.map